import { useAuthStore } from '~/stores/auth'

// The employee half of who sees Stampin' Rewards. canSeeRewards is ONLY "not an
// employee": it is true for a signed-out visitor, so each surface adds its own
// condition. The desktop gift icon adds the CMS `loyalty` prop (and shows for
// guests by design); the account menus are only built for signed-in users; the
// drawer's balance row adds isLoyaltyMember (nuxt2 MobileMenu). RewardsOptInDialog
// keeps its own rule, which also requires a Customer or Demonstrator role.
export const useRewardsVisibility = () => {
  const authStore = useAuthStore()
  const { isAuthenticated, user } = useSAuthState()

  const canSeeRewards = computed(() => !authStore.isEmployee)
  const isLoyaltyMember = computed(() => isAuthenticated.value && !!user.value?.loyaltyOptIn)

  return { canSeeRewards, isLoyaltyMember }
}
